import { Link, Stack } from 'expo-router'
import React from 'react'

export default function NotFoundScreen() {
  return (
    <>
      <Stack.Screen options={{ title: 'Oops!' }} />
      <div className="flex-1 flex flex-col items-center justify-center p-5 min-h-screen bg-background">
        <h1 className="text-2xl font-bold text-foreground text-center">
          This route doesn't exist.
        </h1>
        <Link href="/" className="mt-4 py-4">
          <span className="text-primary hover:underline text-center">
            Go to home screen!
          </span>
        </Link>
      </div>
    </>
  )
}
